export const FETCH_REQUEST_EXIT_PASSES = "FETCH_REQUEST_EXIT_PASSES";
export const FETCH_REQUEST_EXIT_PASS = "FETCH_REQUEST_EXIT_PASS";
export const EDIT_REQUEST_EXIT_PASS = "EDIT_REQUEST_EXIT_PASS";
